module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNXG14zYAAAAWdEVYdENyZWF0aW9uIFRpbWUAMTAtMDYtMTiukHQ0AAAAbklEQVQImWXNuwoFIQxF0XPiC2Jlae2P3o+2EdRMIcgMtwsrm4QpJVNV+FIKWmsQVUWtFUIS3nsIAJCEmBnM7IiZQfbeWGu95Db/8RgDvfdzmeRZATgiIi+5Tz/NV+7gnEMIARJjRM4Zbs75I4kH2LAs9cIzSEIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/topseparator.png
// module id = 96
// module chunks = 0